import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ServicioAlClienteContent from '../components/ServicioAlClienteContent';

const ServicioAlCliente = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
      <Header />
      <ServicioAlClienteContent />
      <Footer />
    </div>
  );
};

export default ServicioAlCliente;
